// removed by extract-text-webpack-plugin
module.exports = {"image":"src-components-modules-Media-MediaSingleImage-style----image-module---image---iRly0","imageReversed":"src-components-modules-Media-MediaSingleImage-style----image-module---imageReversed---1InNH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Media/MediaSingleImage/style/image.module.css
// module id = 257
// module chunks = 221662759943617 248023476013587 254668134183387